// extracted by mini-css-extract-plugin
module.exports = {"block":"e_z6","lead":"e_A6","faces":"e_B6","face":"e_C6","plus":"e_D6","copy":"e_E6","title":"e_F6","text":"e_G6","button":"e_H6","buttonIcon":"e_I6"};